import partnerCartBase from '@/views/config/partner-refer/component/partner-cart-base.vue';
import partnerConfigBase from '@/views/config/partner-refer/component/partner-config-base.vue';

export default {
  components: {
    config: partnerConfigBase,
    cart: partnerCartBase,
  },
};
